// extracted by mini-css-extract-plugin
module.exports = {"chatlist":"style_chatlist__RsABp","textInput":"style_textInput__1uZUJ","chatItem":"style_chatItem__2GJ7y","right":"style_right__3AD-x"};